<template>
  <div>
    <div
      class="d-flex flex-column flex-sm-row justify-sm-center flex-sm-wrap mt-3"
    >
      <div
        v-ripple
        v-for="(item, idx) in walletsToSelect"
        :key="item.name"
        :class="[
          'rounded-10 d-flex flex-column align-center justify-center clickable mt-5 border-default',
          {
            'ml-sm-5': idx > 0,
          },
        ]"
        style="height:108px; width:108px;"
        @click="walletSelected = item"
      >
        <img
          :src="$vuetify.theme.dark ? item.logoDark || item.logo : item.logo"
          alt=""
          height="36px"
          width="36px"
        />
        <div class="mt-1 p-14-r">{{ item.text }}</div>
      </div>
    </div>
    <c-modal
      @onClosed="walletSelected = null"
      :value="!!walletSelected"
      :persistent="true"
      width="647"
    >
      <get-address
        :wallet="walletSelected"
        :project="projectSelected"
        @onAddressSelected="onAddressSelected"
        @onCancelled="walletSelected = null"
        @onError="onConnectError"
      />
    </c-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WALLETS from "@/common/config/wallets";

export default {
  props: ["owners"],
  components: {
    "get-address": () => import("../../index"),
  },
  computed: {
    ...mapGetters({
      walletList: "userWallets/walletList",
      projects: "projectConfig/projects",
    }),
    projectSelected() {
      return this.projects.find(pr => pr.name === "ethereum");
    },
    walletsToSelect() {
      return WALLETS.filter(
        w => w.active && w.projects.includes("ethereum") && w.name !== "gnosis"
      );
    },
  },
  data: () => ({
    walletSelected: null,
  }),
  methods: {
    onAddressSelected(address, metadata) {
      this.$emit("onWalletConnected", {
        type: this.walletSelected.name,
        logo: this.$vuetify.theme.dark
          ? this.walletSelected.logoDark || this.walletSelected.logo
          : this.walletSelected.logo,
        address,
        metadata,
        isOwner: this.owners?.some(
          owner => owner.address.toLowerCase() === address
        ),
      });
      this.walletSelected = null;
    },
    onConnectError(error) {
      this.walletSelected = null;
      this.$store.dispatch("addAlert", {
        type: "error",
        title: "Error",
        message: error.message,
      });
    },
  },
};
</script>
